var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BlueExternalLink } from '@hn-ui/links';
import { forwardRef } from 'react';
import { styled } from 'styled-components';
import { Text } from './Common';
import { Tooltip } from '@hn-ui/tooltips';
var TooltipContainer = styled.div.withConfig({ displayName: "TooltipContainer", componentId: "sc-1vifbzo" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n"], ["\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n"])));
var NewText = styled(Text).withConfig({ displayName: "NewText", componentId: "sc-3esf9z" })(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  color: ", ";\n  font-size: 12px;\n  font-weight: 700;\n  line-height: 16px;\n  letter-spacing: 0.6px;\n  text-transform: uppercase;\n"], ["\n  color: ", ";\n  font-size: 12px;\n  font-weight: 700;\n  line-height: 16px;\n  letter-spacing: 0.6px;\n  text-transform: uppercase;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.red60;
});
var HelpLink = styled(BlueExternalLink).withConfig({ displayName: "HelpLink", componentId: "sc-1ptp9hb" })(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  width: fit-content;\n"], ["\n  width: fit-content;\n"])));
var StuckTooltip = function (_a) {
    var tooltipProps = _a.tooltipProps, onLinkClick = _a.onLinkClick, children = _a.children;
    return (_jsx(Tooltip, __assign({ content: _jsx(StuckTooltipContent, { onLinkClick: onLinkClick }, void 0), maxWidth: '100%' }, tooltipProps, { children: children }), void 0));
};
var StuckTooltipContent = forwardRef(function (_a, ref) {
    var showNewLabel = _a.showNewLabel, onLinkClick = _a.onLinkClick;
    return (_jsxs(TooltipContainer, __assign({ ref: ref }, { children: [showNewLabel && _jsx(NewText, { children: "new" }, void 0), _jsx(Text, { children: "These students have spent more\n      time than expected attempting\n      to complete their tasks." }, void 0), _jsx(HelpLink, __assign({ href: 'https://help.happynumbers.com/en/articles/9405419-stuck-students', onClick: onLinkClick }, { children: "Learn more" }), void 0)] }), void 0));
});
export { StuckTooltip };
var templateObject_1, templateObject_2, templateObject_3;
